import React from "react"

const MyAccountQuickQuoteContext = React.createContext({})

const { Provider, Consumer } = MyAccountQuickQuoteContext

export { Provider, Consumer, MyAccountQuickQuoteContext }
